import Service from '@ember/service';

import { service } from '@ember/service';

export default class ShoeboxService extends Service {
  @service ssr;
  @service store;

  putRecords(key, records) {
    if (!this.ssr.isSsr) {
      return records;
    }
    if (!Array.isArray(records)) {
      this.ssr.shoebox.put(key, null);
      return null;
    }
    const ids = [];
    const data = [];
    const serialized = { ids, data };
    for (const record of records || []) {
      ids.push(record.id);
      data.push(
        record.serialize
          ? record.serialize({ includeId: true })
          : JSON.stringify(record)
      );
    }
    this.ssr.shoebox.put(key, serialized);
    return records;
  }

  retrieveRecords(key, modelName) {
    if (this.ssr.isSsr) {
      return [];
    }
    const serialized = this.ssr.shoebox.retrieve(key);
    if (!serialized) {
      return null;
    }
    const { ids = [], data = [] } = serialized;
    for (const datum of data) {
      this.store.pushPayload(modelName, datum);
    }
    return this.store.peekRecords(modelName, ids);
  }
}
